<script>
import WaveSurfer from "wavesurfer.js";
import RecordRTC from "recordrtc";

export default {
  data() {
    return {
      recorder: null,
      recording: false,
      waveSurferLive: null,
      waveSurferPreview: null,
      audioBlob: null,
      recordingCount: 0,
      recordingPlay: true,
      recordingStop: false,
      recordingReload: false,
      recordingTime: 0,
      recordingProgress: 0,
      countdownInterval: null,
      hideWave: true,
    };
  },
  props: {
    color: {
      type: String,
      default: "#5f2eea",
    },
    totalTime: {
      type: Number,
      default: 15
    }
  },
  methods: {
    uploadFile() {
      if (this.audioBlob) {
        const formData = new FormData();
        formData.append("file", new File([this.audioBlob], "audio.mp3"));
        this.$axios
          .post("/api/Files/upload-file", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.$emit("fileId", res.data.fileId);
          })
          .catch((err) => {
            console.error("Erro ao enviar arquivo:", err);
          });
      } else {
        console.warn("Nenhum blob de áudio disponível para enviar.");
      }
    },

    startRecording() {
      this.recordingCount++;
      this.recordingTime = this.totalTime;
      this.recordingProgress = 0;

      this.countdownInterval = setInterval(() => {
        this.recordingTime--;
        this.recordingProgress =
          ((this.totalTime - this.recordingTime) / this.totalTime) * 100;
        if (this.recordingTime <= 0) {
          clearInterval(this.countdownInterval);
          this.stopRecording();
        }
      }, 1000);

      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          this.recorder = RecordRTC(stream, {
            type: 'audio',
            mimeType: 'audio/wav',
            recorderType: RecordRTC.StereoAudioRecorder,
            numberOfAudioChannels: 1,
            desiredSampRate: 16000,
          });

          this.recorder.startRecording();
          this.recordingPlay = false;
          this.recordingStop = true;
        })
        .catch((error) => {
          console.error("Erro ao acessar o microfone:", error);
        });
    },

    stopRecording() {
      this.recordingStop = false;
      this.recordingReload = true;
      this.hideWave = false;
      if (this.recorder) {
        this.recorder.stopRecording(() => {
          this.audioBlob = this.recorder.getBlob();
          const audioUrl = URL.createObjectURL(this.audioBlob);
          this.$refs.audioPlayer.src = audioUrl;
          this.waveSurferPreview.loadBlob(this.audioBlob);
          this.uploadFile();
        });
        clearInterval(this.countdownInterval);
      }
    },

    reloadRecording() {
      this.audioBlob = null;
      this.recordingCount = 0;
      this.recordingReload = false;
      this.recordingPlay = true;
      this.hideWave = true;
    },

    playPreview() {
      if (this.waveSurferPreview) {
        this.waveSurferPreview.playPause();
      }
    },
  },
  mounted() {
    this.waveSurferPreview = WaveSurfer.create({
      container: this.$refs.previewWaveform,
      waveColor: "grey",
      progressColor: "#5F2EEA",
      responsive: true,
      cursorWidth: 3,
      cursorColor: "#5F2EEA",
      barHeight: 1,
      barWidth: 5,
      barRadius: 5,
      height: 20,
    });
  },
};
</script>
<template>
  <div class="inputStyle">
    <div
      class="controlerButton rotateX"
      @click="playPreview"
      :disabled="!audioBlob"
    >
      <i class="bx bx-play" :style="{color: color}"></i>
    </div>

    <div class="inputBody">
      <audio style="display: none" ref="audioPlayer" controls></audio>
      <div
        id="previewWaveform"
        ref="previewWaveform"
        :class="{ toggleHideWave: hideWave }"
      ></div>

      <div v-if="recordingStop" class="progressContent">
        <div 
        class="progressBar" 
        :style="{ width: recordingProgress + '%' }"
        ></div>
      </div>

      <div v-if="hideWave" class="count">{{ recordingTime }} / {{ totalTime }}</div>
    </div>

    <div
      class="controlerButton rotateX"
      @click="startRecording"
      v-if="recordingPlay"
    >
      <i class="bx bxs-microphone" :style="{color: color}"></i>
    </div>

    <div
      class="controlerButton rotateX"
      @click="stopRecording"
      v-if="recordingStop"
    >
      <i class="bx bx-stop" :style="{color: color}"></i>
    </div>

    <div
      class="controlerButton rotateX"
      @click="reloadRecording"
      v-if="recordingReload"
    >
      <i class="bx bx-refresh" :style="{color: color}"></i>
    </div>
  </div>
</template>
  
  <style scoped>
.controlerButton {
  min-width: 35px;
  min-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  transition: var(--slow-med);
}

.controlerButton:hover {
  background: var(--grey-6);
}

.inputStyle {
  align-items: center;
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.inputBody {
  width: 100%;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: flex-end;
}

#previewWaveform {
  overflow: hidden;
  width: 100%;
}

#previewWaveform.toggleHideWave {
  width: 0%;
}

.progressContent {
  width: 100%;
  background-color: #ddd;
  height: 10px;
  border-radius: 5px;
}

.progressBar {
  height: 100%;
  border-radius: 5px;
  background-color: #5f2eea;
  transition: var(--slow-med) ease;
}

i.bx.bx-play,
i.bx.bx-stop,
i.bx.bx-refresh {
  font-size: 24px;
}

i.bx.bxs-microphone {
  font-size: 20px;
}

.count {
  white-space: nowrap;
  font-size: 14px;
  font-weight: 400;
}
</style>
  